<template>
  <div class="workCompletionApproval">
    <h1>作業完了承認</h1>

    <!-- ***** header card start ***** -->
    <v-card outlined class="mb-5">
      <v-expansion-panels flat v-model="expandedPanel" multiple>
        <v-expansion-panel>
          <!-- Header -->
          <v-expansion-panel-header>
            <span class="headline">検索条件</span>
          </v-expansion-panel-header>

          <!-- expansion panel body -->
          <v-expansion-panel-content class="mt-3">
            <v-row>
              <p class="text-center pt-8 px-3">施設</p>

              <v-autocomplete
                v-model="targetHospital"
                :items="hospitalsList"
                outlined
                label="病院選択"
                item-text="name"
                item-value="code"
                chips
                return-object
              ></v-autocomplete>
            </v-row>

            <v-row style="height: 80px;">
              <!-- <v-col cols="1" class="d-inline-block"> -->
              <p class="range-text text-center pt-7 pl-3">作業日</p>
              <!-- </v-col> -->
              <v-col cols="5">
                <DatePicker
                  v-model="workDateFrom"
                  label="作業日From"
                  prepend-inner-icon="mdi-calendar"
                  type="day"
                  outlined
                  clearable
                  reactive
                />
              </v-col>
              <v-col cols="1">
                <p class="range-text text-center pt-7">〜</p>
              </v-col>
              <v-col cols="5">
                <DatePicker
                  v-model="workDateTo"
                  label="作業日To"
                  prepend-inner-icon="mdi-calendar"
                  type="day"
                  outlined
                  clearable
                  reactive
                />
              </v-col>
            </v-row>

            <v-row>
              <!-- <v-col cols="1"> -->
              <p class="text-center pt-8 px-3">対象</p>
              <!-- </v-col> -->

              <v-col cols="2">
                <v-checkbox
                  v-model="anyApprovalPending"
                  label="誰か一人でも未承認"
                  @change="handleAnyPendingChange"
                ></v-checkbox>
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  v-model="selfApprovalPending"
                  label="自分の承認が未了"
                  @change="handleSelfPendingChange"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-actions class="mx-2">
        <v-spacer></v-spacer>
        <Btn color="info" icon="file-import" @click="getWCAData('query')"
          >取得</Btn
        >
      </v-card-actions>
    </v-card>
    <!-- ***** header card end ***** -->

    <!-- ***** table card start ***** -->
    <v-card class="mt-5">
      <v-data-table
        :headers="scheduleHeaders"
        :items="dataItems"
        :items-per-page="-1"
        class="elevation-1"
      >
        <!-- テブルヘダー header  --- TABLE HEADER -->
        <template v-slot:header>
          <thead class="light-blue accent-1">
            <tr>
              <th rowspan="2" class="">作業日</th>
              <th rowspan="2" class="">作業時間</th>
              <th rowspan="2" class="">作業責任者</th>
              <th rowspan="2" class="">施設名</th>
              <th rowspan="2" class="">作業内容</th>
              <th rowspan="2" class="recentCommentTimestampHeader">
                最後コメント日時
              </th>
              <th rowspan="2" class="recentCommentHeader">最後コメント</th>
              <!-- <th :colspan="getAllUniqueApprovers.length" class="text-center"> -->
              <th :colspan="maxApprovers" class="text-center">
                承認者
              </th>
              <th colspan="5" class=""></th>
            </tr>
          </thead>
        </template>

        <!-- TABLE DATA 「ROW MODEL」 -->
        <template v-slot:item="{ item }" v-if="dataItems.length > 0">
          <tr
            :class="
              item.approversList.some(a => a.approvalStatus === '2')
                ? ['red lighten-3']
                : ''
            "
          >
            <!-- <tr class="workCompletionApprovalSchedule"> -->
            <td class="">
              {{ item.workDate }}
            </td>
            <td class="">
              {{ item.workTime }}
            </td>
            <td class="">
              {{ item.workSupervisor }}
            </td>
            <td class="wrap-facility">
              {{ item.facilityName }}
            </td>
            <td class="wrap-workContents">
              {{ item.workContents }}
            </td>
            <!--   -->
            <td class="recentCommentTimestamp">
              {{
                item.commentHistoryList.length > 0
                  ? item.commentHistoryList[0].timestamp
                  : "無"
              }}
            </td>
            <td class="recentComment">
              {{
                item.commentHistoryList.length > 0
                  ? item.commentHistoryList[0].comment
                  : "無"
              }}
            </td>

            <!-- approvers col block --- START *****  -->
            <td
              v-for="approver in item.approversList"
              :key="approver.approverUserId"
              class=""
            >
              <!-- 承認者 // ApproverName 表示-->
              <tr class="text-center">
                <td>{{ approver.approverName }}</td>
              </tr>

              <!-- 承認ステータス // ApprovalStatus -->
              <tr class="text-center">
                <td v-if="approver.approvalStatus === '0'" class="red--text">
                  (未)
                </td>
                <td v-else-if="approver.approvalStatus === '1'">
                  (承認)
                </td>
                <td v-else-if="approver.approvalStatus === '2'">
                  (差戻)
                </td>
                <td v-else></td>
              </tr>
            </td>

            <!-- approvers col block --- END  *****  -->

            <!-- buttons columns --
            <td>
              <div class="d-flex justify-center ">
                <v-btn @click="inspect(item)" class="blue--text">確認</v-btn>
              </div>
            </td>
            <td>
              <div class="d-flex justify-center">
                <v-btn @click="approve(item)" class="green--text">承認</v-btn>
              </div>
            </td>
            <td>
              <div class="d-flex justify-center">
                <v-btn @click="openSasimodosuDialog(item)" class="red--text"
                  >差戻</v-btn
                >
              </div>
            </td>
            <td>
              <div class="d-flex justify-center">
                <v-btn
                  @click="openCommentHistoryDialog(item)"
                  class="orange--text"
                  >履歴</v-btn
                >
              </div>
            </td>
            !--  buttons columns END -->

            <!-- buttons columns v2.0 -->
            <td class="">
              <div class="d-flex align-self-center justify-space-between">
                <v-btn
                  @click="inspect(item)"
                  class="blue--text mr-2"
                  :loading="downloadingScheduleIds.has(item.scheduleId)"
                  >確認</v-btn
                >
                <v-btn
                  @click="approve(item)"
                  class="green--text mr-2"
                  :disabled="!inspectedScheduleIds.has(item.scheduleId)"
                  >承認</v-btn
                >
                <v-btn
                  @click="openSasimodosuDialog(item)"
                  class="red--text mr-2"
                  >差戻</v-btn
                >
                <v-btn
                  @click="openCommentHistoryDialog(item)"
                  class="orange--text"
                  >履歴</v-btn
                >
              </div>
            </td>
            <!-- buttons columns v2.0 END -->
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <!-- ***** table card end ***** -->

    <!-- ***** sasimodosuReasonDialog START ***** -->
    <v-dialog v-model="displaySasimodosuDialog" persistent max-width="600px">
      <v-card class="">
        <!-- dialog Title -->
        <v-toolbar class="white--text" elevation="0" color="primary">
          <v-toolbar-title>
            差し戻す理由
          </v-toolbar-title>
        </v-toolbar>

        <!-- dialog body -->
        <v-card-text class="pa-0">
          <v-container>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-textarea
                  v-model="sasimodosuReason"
                  class="sasimodosuReason"
                  label="差戻理由"
                  required
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeSasimodosuDialog()">閉じる</v-btn>
          <v-btn
            color="success"
            @click="modosu(updateTargetSchedule)"
            :disabled="sasimodosuReason.length == ''"
            >差し戻す</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ***** sasimodosuReasonDialog END ***** -->

    <!-- ***** commentHistoryDialog START ***** -->
    <v-dialog
      v-model="displayCommentHistoryDialog"
      persistent
      max-width="600px"
    >
      <v-card class="">
        <!-- dialog Title -->
        <v-toolbar class="white--text" elevation="0" color="primary">
          <v-toolbar-title>
            作業完了承認コメント履歴
          </v-toolbar-title>
        </v-toolbar>

        <!-- dialog body -->
        <v-card-text class="pa-0">
          <v-container
            v-if="
              Array.isArray(targetCommentHistoryList) &&
                targetCommentHistoryList.length > 0
            "
          >
            <v-row>
              <v-col cols="12" class="pa-0 pb-3">
                <v-data-table
                  :headers="commentHistoryHeaders"
                  :items="targetCommentHistoryList"
                  :items-per-page="5"
                  class="elevation-1"
                >
                  <!-- テブルヘダー  ---  CommentHistoryTable  --- TABLE HEADER -->
                  <template v-slot:header>
                    <thead class="light-blue accent-1">
                      <tr>
                        <th class="">日時</th>
                        <th class="">承認役割</th>
                        <th class="">登録者</th>
                        <th class="">区分</th>
                        <th class="">コメント</th>
                      </tr>
                    </thead>
                  </template>

                  <!-- TABLE DATA 「ROW MODEL」 -->
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="">{{ item.timestamp }}</td>
                      <td class="">{{ item?.roll }}</td>
                      <td class="">{{ item?.commenter }}</td>
                      <td class="">{{ item?.category }}</td>
                      <td class="recentComment">{{ item?.comment }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-else class="pl-6 pt-5">
            コメント履歴なし
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeCommentHistoryDialog()"
            >閉じる</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openApprovalDialog" persistent max-width="600px">
      <v-card class="">
        <!-- dialog Title -->
        <v-toolbar class="white--text" elevation="0" color="primary">
          <v-toolbar-title>
            承認
          </v-toolbar-title>
        </v-toolbar>

        <!-- dialog body -->
        <v-card-text class="pa-0">
          <v-container>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-textarea
                  v-model="approvalComment"
                  label="コメント"
                  required
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeApprovalDialog()"
            >承認せずに閉じる</v-btn
          >
          <v-btn color="success" @click="approval(updateTargetSchedule)"
            >承認</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ***** commentHistoryDialog END ***** -->

    <!-- ***** pdfPreviewDialog START ***** -->
    <v-dialog
      v-model="displayPdfPreviewDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="d-flex flex-column" style="height: 100vh;">
        <v-toolbar dense color="primary" dark flat class="flex-grow-0">
          <v-toolbar-title>定期作業完了書プレビュー</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text dark @click="downloadExcelFromPreview">
            <v-icon left>mdi-file-excel</v-icon>Excel ダウンロード
          </v-btn>
          <v-btn icon @click="closePdfPreview">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0 flex-grow-1" style="overflow: hidden;">
          <iframe
            v-if="previewPdfUrl"
            :src="previewPdfUrl"
            @load="onPdfLoaded"
            style="width:100%; height:100%; border:none;"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ***** pdfPreviewDialog END ***** -->
  </div>
</template>

<script>
// mixins
import Common from "@/mixins/common";
import ShowDialogs from "@/mixins/showDialogs";

import Api from "@/mixins/api";
import WorkCompletionApproval from "@/models/WorkCompletionApproval";

const DATENOW = new Date();

const DATETO = DATENOW.toISOString().slice(0, 10); // DATETO format -> YYYY-MM-DD

// need new Date var for DATEFROM calc not referencing DATENOW but with exact same DATENOW values
const DATEFROMSTR = new Date(DATENOW);
DATEFROMSTR.setFullYear(DATEFROMSTR.getFullYear() - 1);
DATEFROMSTR.setDate(DATEFROMSTR.getDate() + 1);

const DATEFROM = DATEFROMSTR.toISOString().slice(0, 10);

export default {
  name: "WorkCompletionApproval",
  mixins: [Common, Api, ShowDialogs],
  data: () => ({
    expandedPanel: [0],
    workDateFrom: DATEFROM,
    workDateTo: DATETO,
    // siteiNasi: false,
    // allApprovalPending: false,
    selfApprovalPending: true,
    anyApprovalPending: false,

    scheduleHeaders: [], // テンプレートに設定しています。 //  headers are unused in custom header slot
    commentHistoryHeaders: [], // テンプレートに設定しています。 //  headers are unused in custom header slot
    dataItems: [
      // {                                        //<--- no compulsory need to init the props since we have set it from apiresponse.
      //   scheduleId: "",
      //   workDate: "",
      //   workTime: "",
      //   hojinCd: "",
      //   hospitalCd: "",
      //   packageNo: "",
      //   workSupervisor: "",
      //   facilityName: "",
      //   workContents: "",
      //   commentHistoryList: [],
      //   approversList: []
      // }
    ],
    inspectedScheduleIds: new Set(), // 閲覧済scheduleIdの管理
    downloadingScheduleIds: new Set(), // 閲覧ボタンローディング制御（閲覧ファイルのDL中のLoading制御）
    displaySasimodosuDialog: false, //<-- flag to open the sasimodosuCommentEntry Dialog
    sasimodosuReason: "",
    updateTargetSchedule: new WorkCompletionApproval(),
    recentCommentHistory: null,
    displayCommentHistoryDialog: false, //<-- flag to open the CommentHistoryDialog
    targetCommentHistoryList: [
      // {
      //   addDatetime: "",
      //   comment: "",
      //   scheduleId: "",
      //   userId: ""
      // }
    ],
    hospitalsList: [],
    targetHospital: {
      code: "",
      name: ""
    },
    openApprovalDialog: false,
    approvalComment: "",
    // PDFプレビューモーダル関連
    displayPdfPreviewDialog: false,
    previewPdfUrl: null,
    previewSchedule: null
  }),
  computed: {
    // 最大承認者数
    maxApprovers() {
      return Math.max(...this.dataItems.map(item => item.approversList.length));
    }
  },
  methods: {
    async getHospitalList() {
      console.log("getHospitalList method => getting HospitalList");
      const hospitalListResponse = await this.$get(this.Paths.hpFilter);
      console.log("hospitalListResponse=>", hospitalListResponse);
      return hospitalListResponse;
    },
    async getWCAData(pathparam) {
      this.$loading();
      // this.inspectedScheduleIds = new Set(); // コメントアウト解除で取得ボタン押下時に閲覧済scheduleIdを初期化
      this.downloadingScheduleIds = new Set();
      try {
        console.log("dateFrom=>", DATEFROM);
        console.log("loginUserId=>", this.$store.state.userincode);
        // console.log("calling getWCAData method");
        console.log("anyApprovalPending => ", this.anyApprovalPending);
        console.log("selfApprovalPending => ", this.selfApprovalPending);

        const param = {
          workDateFrom: this.workDateFrom,
          workDateTo: this.workDateTo,
          // siteiNasi: this.siteiNasi,
          // allApprovalPending: this.allApprovalPending,
          selfApprovalPending: this.selfApprovalPending,
          anyApprovalPending: this.anyApprovalPending,
          targetHospital: this.targetHospital
        };
        const encodedParam = encodeURI(JSON.stringify(param));
        console.log("param => ", param);
        console.log("encodedParam => ", encodedParam);
        const apiResponse = await this.$get(
          this.Paths.workCompletionApproval,
          pathparam + "=" + encodedParam
        );

        console.log("apiResult => ", apiResponse);
        this.updateDataItems(apiResponse);
      } catch (e) {
        this.$error(e.message);
      } finally {
        this.$unloading();
      }
    },
    async inspect(schedule) {
      console.log("calling inspect method", schedule);
      // this.$router.push("/workcompletionreport");

      const outputExcelData = [];
      outputExcelData.push({
        hojinCd: schedule.hojinCd,
        hospitalCd: schedule.hospitalCd,
        hospitalName: schedule.facilityName,
        packageNos: schedule.packageNo,
        yearMonthDay: schedule.scheduleDate,
        yearMonthDayTo: schedule.scheduleDate,
        keyid: schedule.scheduleId
      });

      // DL開始：ローディング表示
      this.downloadingScheduleIds = new Set([
        ...this.downloadingScheduleIds,
        schedule.scheduleId
      ]);

      try {
        const encode = encodeURI(JSON.stringify(outputExcelData));
        // PDF取得（新エンドポイント）
        const pdfBlob = await this.$downloadpdf(
          this.Paths.workCompletionReportPdf,
          "records=" + encode
        );

        // モーダル表示用に Blob URL 生成
        this.previewPdfUrl = URL.createObjectURL(pdfBlob);
        this.previewSchedule = schedule;

        // モーダルを開く（承認ボタン活性化は iframe @load = onPdfLoaded で実行：③ ii 案）
        this.displayPdfPreviewDialog = true;
      } catch (e) {
        this.$error(e.message);
        // 失敗時は承認ボタンを活性化しない
      } finally {
        // DL中フラグを解除
        const next = new Set(this.downloadingScheduleIds);
        next.delete(schedule.scheduleId);
        this.downloadingScheduleIds = next;
        this.$unloading();
        console.log("pdf:preview", "end");
      }
    },
    onPdfLoaded() {
      // PDF が iframe に表示された時に承認ボタンを活性化（顧客回答 ③ ii 案）
      if (this.previewSchedule) {
        this.inspectedScheduleIds = new Set([
          ...this.inspectedScheduleIds,
          this.previewSchedule.scheduleId
        ]);
      }
    },
    closePdfPreview() {
      // Blob URL を解放（メモリリーク防止）
      if (this.previewPdfUrl) {
        URL.revokeObjectURL(this.previewPdfUrl);
      }
      this.previewPdfUrl = null;
      this.previewSchedule = null;
      this.displayPdfPreviewDialog = false;
    },
    async downloadExcelFromPreview() {
      // モーダル内 Excel DL リンク（顧客回答 ② B 案）
      // 既存 $downloadexcel を流用（既存 /output_wcr エンドポイント）
      if (!this.previewSchedule) return;
      const schedule = this.previewSchedule;
      const outputExcelData = [];
      outputExcelData.push({
        hojinCd: schedule.hojinCd,
        hospitalCd: schedule.hospitalCd,
        hospitalName: schedule.facilityName,
        packageNos: schedule.packageNo,
        yearMonthDay: schedule.scheduleDate,
        yearMonthDayTo: schedule.scheduleDate,
        keyid: schedule.scheduleId
      });
      try {
        const encode = encodeURI(JSON.stringify(outputExcelData));
        const result = await this.$downloadexcel(
          this.Paths.workCompletionReportSite,
          "records=" + encode
        );
        const url = URL.createObjectURL(result);
        const link = document.createElement("a");
        link.href = url;
        link.download = "定期作業完了書.zip";
        link.click();
        URL.revokeObjectURL(url); // Blob URL を解放（memory leak 防止）
      } catch (e) {
        this.$error(e.message);
      }
    },
    async approve(schedule) {
      const approversList = schedule.approversList;

      // ログインユーザーの承認者情報をすべて取得
      const loginUserApprovers = approversList?.filter(r =>
        r.approverUserId.includes(String(this.$store.state.userincode))
      );

      // 承認者情報が存在しない場合
      if (!loginUserApprovers || loginUserApprovers.length === 0) {
        this.$warning("承認・差戻権限がありません。");
        return;
      }

      // 未承認(approvalStatus !== "1")のものを優先的に取得
      let loginUserApprover = loginUserApprovers.find(
        r => r.approvalStatus !== "1"
      );

      // すべて承認済みの場合は最後の要素を取得
      if (!loginUserApprover) {
        loginUserApprover = loginUserApprovers[loginUserApprovers.length - 1];
      }

      // 承認ステータスが空の場合
      if (loginUserApprover.approvalStatus === "") {
        this.$warning("承認・差戻権限がありません。");
      }
      // 既に承認済みの場合
      else if (loginUserApprover.approvalStatus === "1") {
        this.$warning("既に承認済みです。");
      }
      // 承認処理実行
      else {
        // 副担当として承認する場合は確認メッセージを表示
        if (loginUserApprover.isDeputy) {
          const confirmed = await this.$confirm(
            `"${loginUserApprover.approverName}"の承認を代理で実施しますか？`
          );
          if (!confirmed) return;
        }
        //this.updateApprovalFlag(this.Paths.approveSchedule, schedule);
        this.updateTargetSchedule = schedule;
        this.openApprovalDialog = true;
      }
    },
    async modosu(schedule) {
      console.log("calling modosu method");
      console.log(schedule);

      console.log("sasimodosuReason=> ", this.sasimodosuReason);

      schedule.sasimodosuReason = this.sasimodosuReason;
      console.log("scheduleTarget=> ", schedule);
      this.updateApprovalFlag(this.Paths.sasimodosuSchedule, schedule);
    },
    async approval(schedule) {
      schedule.approvalComment = this.approvalComment;
      console.log("scheduleTarget=> ", schedule);
      this.updateApprovalFlag(this.Paths.approveSchedule, schedule);
    },
    async history(schedule) {
      // console.log("calling history method");
      console.log(schedule);
    },

    openSasimodosuDialog(schedule) {
      const approversList = schedule.approversList;

      // ログインユーザーの承認者情報をすべて取得(逆順にソート)
      const loginUserApprovers = approversList
        ?.filter(r =>
          r.approverUserId.includes(String(this.$store.state.userincode))
        )
        .sort((a, b) => b.approverSort - a.approverSort); // 降順にソート

      // 承認者情報が存在しない場合
      if (!loginUserApprovers || loginUserApprovers.length === 0) {
        this.$warning("承認・差戻権限がありません。");
        return;
      }

      // 承認(approvalStatus === "1")のものを優先的に取得
      let loginUserApprover = loginUserApprovers.find(
        r => r.approvalStatus === "1"
      );

      // 承認済みが無ければ未承認(approvalStatus === "0")のものを優先的に取得
      if (!loginUserApprover) {
        loginUserApprover = loginUserApprovers.find(
          r => r.approvalStatus === "0"
        );
      }

      // 上記条件で取得できなければ最後の要素を取得(逆順なので実質最小のapproverSort)
      if (!loginUserApprover) {
        loginUserApprover = loginUserApprovers[loginUserApprovers.length - 1];
      }

      // 承認ステータスが空の場合
      if (loginUserApprover.approvalStatus === "") {
        this.$warning("承認・差戻権限がありません。");
      }
      // 未承認の場合
      // if (loginUserApprover.approvalStatus === "0") {
      //   this.$warning("承認されていません。");
      // }
      // 既に差戻済みの場合
      else if (loginUserApprover.approvalStatus === "2") {
        this.$warning("既に差戻済みです。");
      }
      // 差戻処理実行
      else {
        this.updateTargetSchedule = schedule;
        this.displaySasimodosuDialog = true;
      }
    },
    closeSasimodosuDialog() {
      this.displaySasimodosuDialog = false;
      this.sasimodosuReason = "";
    },
    closeApprovalDialog() {
      this.openApprovalDialog = false;
      this.approvalComment = "";
    },

    openCommentHistoryDialog(schedule) {
      this.displayCommentHistoryDialog = true;

      if (
        Array.isArray(schedule.commentHistoryList) &&
        schedule.commentHistoryList.length > 0
      ) {
        this.targetCommentHistoryList = schedule.commentHistoryList;
      } else {
        this.targetCommentHistoryList = []; // fallback to empty array
      }
    },
    closeCommentHistoryDialog() {
      this.displayCommentHistoryDialog = false;
    },

    // ***************************************************************************
    async updateApprovalFlag(apiPathName, schedule) {
      // console.log("calling updateApprovalFlag method");
      // console.log("schedule.scheduleId =>",schedule.scheduleId,"schedule.workDate =>",schedule.workDate," schedule.workTime =>",schedule.workTime," schedule.workSupervisor =>",schedule.workSupervisor," schedule.facilityName =>",schedule.facilityName," schedule.workContents =>",schedule.workContents," schedule.approversList =>",schedule.approversList);

      const param = new WorkCompletionApproval(
        schedule.scheduleId,
        schedule.workDate,
        schedule.workTime,
        schedule.workSupervisor,
        schedule.facilityName,
        schedule.workContents,
        schedule.approversList,
        schedule.sasimodosuReason,
        schedule.approvalComment
      );
      console.log("updateReqParam=> ", param);

      // const result = await this.$post(this.Paths.sasimodosuSchedule, param);
      const result = await this.$post(apiPathName, param);
      console.log("modosu-postResult=> ", result);

      if (apiPathName == this.Paths.sasimodosuSchedule) {
        console.log("turning smReasonFlag off");
        this.displaySasimodosuDialog = false;
      }

      if (apiPathName == this.Paths.approveSchedule) {
        this.openApprovalDialog = false;
        this.approvalComment = "";
      }

      switch (result) {
        case "承認・差戻権限がありません。。":
          this.$warning(result);
          break;
        // case "承認しました。":
        //   break;
        case "差し戻しました。":
        case "既に承認済みです。":
        case "既に差戻済みです。":
          this.$info(result);
          break;
      }
      this.getWCAData("query");
    },
    // ***************************************************************************

    updateDataItems(apiResponse) {
      this.dataItems = apiResponse.map(item => ({
        //<--- only updates the data after 取得btn click
        scheduleId: item.scheduleId,
        workDate: item.workDate || "", // Fallback to empty string if undefined
        workTime: item.workTime || "",
        hojinCd: item.hojinCd || "",
        hospitalCd: item.hospitalCd || "",
        packageNo: item.packageNo || "",
        scheduleDate: item.scheduleDate || "",
        workSupervisor: item.workSupervisor || "",
        facilityName: item.facilityName || "",
        workContents: item.workContents || "",
        commentHistoryList: Array.isArray(item.approvalCommentHistoryList)
          ? item.approvalCommentHistoryList.map(commentHistory => ({
              timestamp: commentHistory.timestamp,
              commenter: commentHistory.commenter,
              comment: commentHistory.comment,
              category: commentHistory.category,
              roll: commentHistory.roll
            }))
          : [
              {
                timestamp: "N/A",
                commenter: "N/A",
                comment: "N/A"
              }
            ],
        approversList: Array.isArray(item.approversList)
          ? item.approversList.map(approver => ({
              approverName: approver.approverName,
              approverRollId: approver.approverRollId,
              approverUserId: approver.approverUserId,
              approvalStatus: approver.approvalStatus,
              approverSort: approver.approverSort,
              isDeputy: approver.isDeputy ?? false
            }))
          : [
              {
                approverName: "N/A",
                approverRollId: "N/A",
                approverUserId: "N/A",
                approvalStatus: "N/A",
                approverSort: "N/A"
              }
            ] // Fallback to empty array if approvers is undefined or not an array
      }));

      console.log("updatedDataItems => ", this.dataItems);
      // console.log("recentComment => ", this.dataItems[0].commentHistoryList[0].addDatetime," ",this.dataItems[0].commentHistoryList[0].comment);
    },
    handleAnyPendingChange() {
      if (this.anyApprovalPending) {
        this.selfApprovalPending = false;
      }
    },
    handleSelfPendingChange() {
      if (this.selfApprovalPending) {
        this.anyApprovalPending = false;
      }
    },
    ModosuApproverIndex(item) {
      return item.approversList.findIndex(
        approver => approver.approvalStatus === "2"
      );
    }
  }, //<--- methods END Tag
  async created() {
    // console.log("created");
    // 病院選択オプション  /  get the HospitalList
    this.hospitalsList = await this.getHospitalList();
  },
  async mounted() {
    // console.log("hola from mounted");
    // call the apiCallingfunction and update the dataItems
    this.getWCAData("query");
  }
};
</script>

<!-- <style> -->
<style scoped>
.workCompletionApproval .wrap-workContents {
  white-space: normal !important; /* Allow wrapping */
  word-break: break-word; /* Break words if needed */
  max-width: 260px; /* Optional: prevent growing too wide */
}
.workCompletionApproval .wrap-facility {
  white-space: normal !important; /* Allow wrapping */
  word-break: break-word; /* Break words if needed */
  max-width: 150px; /* Optional: prevent growing too wide */
}
.workCompletionApproval .recentCommentTimestamp {
  white-space: normal !important; /* Allow wrapping */
  word-break: break-word; /* Break words if needed */
  max-width: 150px; /* Optional: prevent growing too wide */
}
.workCompletionApproval .recentComment {
  white-space: normal !important; /* Allow wrapping */
  word-break: break-word; /* Break words if needed */
  max-width: 200px; /* Optional: prevent growing too wide */
}
.workCompletionApproval .approver {
  min-width: 100px;
}
.workCompletionApproval .workCompletionApprovalSchedule td.yellow {
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important; */
  /* border-color: rgba(0, 0, 0, 0.12) !important;   <--- uncomment this line for visible border between consecutive modosu schedules. need to add .workCompletionApprovalSchedule in tr */
}

.workCompletionApproval .workCompletionApprovalSchedule:hover {
  /* this is for removal of the overlay like bg-color while hovering. need to add .workCompletionApprovalSchedule in tr */
  /* background: none !important; */
}

@media (max-width: 1500px) {
  .workCompletionApproval .recentCommentTimestampHeader,
  .workCompletionApproval .recentCommentHeader,
  .workCompletionApproval .recentCommentTimestamp,
  .workCompletionApproval .recentComment {
    display: none;
  }
}

@media (max-width: 1080px) {
  .workCompletionApproval
    .v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td {
    padding: 0 8px;
  }
}
</style>
